<div [formGroup]="form" class="">
    <div class=" d-flex justify-content-center align-items-center">
        <!--photo div-->
        <div class="mt-top-2 field mx500">
            <div class="d-flex justify-content-center  align-items-center w-100 h-100">
                <div class="position-relative my-4 iconPic displayPic">
                    <div [className]="getStyle()">
                        <img *ngIf="!imgURL" class=" mx-100 default-img list-img-inn " alt=""
                            src="../../assets/images/trade.svg" />
                        <img *ngIf="imgURL" alt="" [src]="imgURL" class="list-img-inn">
                    </div>
                    <div class="d-flex">
                        <div class="position-absolute align-icon align-helmet cursor" *ngIf="!imgURL"
                            (click)="imageInput.click()"><em class="fas fa-camera camera-icon"></em></div>
                        <div *ngIf="imgURL && !view" class="position-absolute align-icon align-helmet cursor"
                            (click)="deleteImage()"><em class="fas fa-trash-alt camera-icon"></em></div>
                    </div>

                </div>
                <input #imageInput type="file" (change)="onImageSelected($event)" style="display:none;" accept="image/*">
                <div class="icon-mssg ml-4 position-relative">
                    <div>Only SVG images are allowed</div>
                    <div *ngIf="imgURL == null  && submitted" class="err-mssg ml-4 font-weight-bold">
                        <div>Trade Image is required</div>
                    </div>
                    <div *ngIf="submitted && imgURL == null && !isImageSaved" class="err-mssg ml-2 mt-4 font-weight-bold">
                        <div>{{errorMessage}}</div>
                    </div>
                    <div *ngIf="imageError" class="err-mssg ml-4 mt-4 font-weight-bold">{{imageError}}</div>
                </div>
            </div>
        </div>
        <!--Photo div ends-->
    </div>
    <div class="make-responsive-fit">
        <div class="mt-top-2 field">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput formControlName="name">
                <ng-container *ngIf="submitted && nameFormValues['name'].errors">
                    <mat-error *ngIf="nameFormValues['name'].errors?.['required']">
                        <em class="fas fa-exclamation-circle mr-2"></em>Name is required
                    </mat-error>
                    <mat-error *ngIf="nameFormValues['name'].errors?.['pattern']">
                        <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                        </mat-error>
                </ng-container>
            </mat-form-field>

        </div>
        <div class="mt-top-2 field -text-area-field-height">
            <mat-form-field>
                <mat-label>Description</mat-label>
                <textarea matInput cdkTextareaAutosize formControlName="description" #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
                <ng-container *ngIf="submitted && nameFormValues['description'].errors">
                    <mat-error *ngIf="nameFormValues['description'].errors?.['required']">
                        <em class="fas fa-exclamation-circle mr-2"></em>Description is required
                    </mat-error>
                    <mat-error *ngIf="nameFormValues['description'].errors?.['pattern']">
                        <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                        </mat-error>
                </ng-container>
            </mat-form-field>
        </div>
    </div>